import type { ComponentProps } from "react";

export default function CompanyIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.009 0C11.1582 0.00225 11.3052 0.0480002 11.4305 0.13575C11.6307 0.276 11.75 0.5055 11.75 0.75V17.25C11.75 17.661 11.4193 17.9947 11.0098 18H11H2.75C2.336 18 2 17.664 2 17.25C2 17.25 2 7.97475 2 4.80075C2 3.85425 2.59175 3.00975 3.48125 2.68575C5.67125 1.89 10.7435 0.045 10.7435 0.045C10.823 0.0165 10.9047 0.0015 10.9865 0H10.9977H11.009ZM13.25 6.1485L15.6365 7.17075C16.4637 7.5255 17 8.33925 17 9.23925V17.25C17 17.664 16.664 18 16.25 18H13.1217C13.205 17.7652 13.25 17.5133 13.25 17.25V6.1485ZM8.00975 12.75C8.41925 12.7448 8.75 12.411 8.75 12C8.75 11.586 8.414 11.25 8 11.25H5.75C5.336 11.25 5 11.586 5 12C5 12.414 5.336 12.75 5.75 12.75H8H8.00975ZM8.00975 9.75C8.41925 9.74475 8.75 9.411 8.75 9C8.75 8.586 8.414 8.25 8 8.25H5.75C5.336 8.25 5 8.586 5 9C5 9.414 5.336 9.75 5.75 9.75H8H8.00975ZM8.00975 6.75C8.41925 6.74475 8.75 6.411 8.75 6C8.75 5.586 8.414 5.25 8 5.25H5.75C5.336 5.25 5 5.586 5 6C5 6.414 5.336 6.75 5.75 6.75H8H8.00975Z"
        fill={props.fill || "#183E7A"}
      />
    </svg>
  );
}
